import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';

export const useCustomerEScripCheck = (customerID: string) => {
  const { data: precheckData, loading: loadingPreCheck } = useQuery(
    graphql(`
      query preCheck($customerID: String) {
        preCheckPrescription(customerID: $customerID) {
          ok
          message
        }
      }
    `),
    { fetchPolicy: 'cache-and-network', variables: { customerID: customerID } },
  );

  return { precheckData, loadingPreCheck };
};
